import React, { useState } from 'react';
import { Tabs, TabList, Tab, TabPanels, TabPanel, Text, Flex, Image, Link, VStack, Divider } from '@chakra-ui/react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import JobSuggestionCard from './JobSuggestionCard';

const AboutCompany = () => {
  const [selectedTab, setSelectedTab] = useState('Company Info');

  const companyInfo = {
    name: 'Penta Consulting Limited',
    sector: 'Employer (Private Sector)',
    employees: '100-499 Employees or more',
    location: 'Riyadh, Saudi Arabia',
    contact: 'contact@penta.com',
    website: 'https://www.penta.com',
    about: 'Multi-award winning Penta Consulting is one of the most successful ICT recruitment companies operating in over 85 countries across the world.',
  };

  const jobs = [
    { jobTitle: 'Front End Engineer', company: 'Penta Consulting Limited', location: 'Riyadh, Saudi Arabia', date: 'Oct 17', vacancies: 1 },
    { jobTitle: 'Back End Developer', company: 'Penta Consulting Limited', location: 'Riyadh, Saudi Arabia', date: 'Sep 17', vacancies: 2 },
    { jobTitle: 'Front End Engineer', company: 'Penta Consulting Limited', location: 'Riyadh, Saudi Arabia', date: 'Oct 17', vacancies: 1 },
    { jobTitle: 'Back End Developer', company: 'Penta Consulting Limited', location: 'Riyadh, Saudi Arabia', date: 'Sep 17', vacancies: 2 },
  ];

  return (
    <>
      <Flex direction="column" alignItems="flex-start" mb={4}>
        <Image boxRadius="md" boxSize="80px" src="https://www.bookdialysis.com/storage/1080/conversions/img-hospital-7y1Iz-1-profile.jpg" alt="Company Logo" mb={2} />
        <VStack align="start" spacing={1} mb={4}>
          <Text fontSize="xl" fontWeight="bold">{companyInfo.name}</Text>
          <Text>{companyInfo.sector}</Text>
          <Text>{companyInfo.employees}</Text>
        </VStack>
        <Link href={companyInfo.website} color="blue.500" isExternal mb={4} display="flex" alignItems="center">
          Visit Company Website <FaExternalLinkAlt style={{ marginLeft: '8px' }} />
        </Link>
      </Flex>

      <Divider mb={4} />

      <Tabs  variant="unstyled" onChange={(index) => setSelectedTab(index === 0 ? 'Company Info' : 'Jobs')}>
        <TabList mb={4} gap={4}>
          <Tab
            _selected={{ color: 'blue.500', fontWeight: 'bold', borderRadius: 'none', borderBottom: '3px solid', borderColor: 'blue.500' }}
            color="gray.500"
            mr={4}
            mb={0.5}
            pb={2}
            _hover={{ bg: 'transparent' }}
          >
            Company Info
          </Tab>
          <Tab
            _selected={{ color: 'blue.500', fontWeight: 'bold', borderRadius: 'none', borderBottom: '3px solid', borderColor: 'blue.500' }}
            color="gray.500"
            mb={0.5}
            pb={2}
            _hover={{ bg: 'transparent' }}
          >
            Jobs
          </Tab>
        </TabList>

        <TabPanels  height="280px" overflowY="auto">
          <TabPanel textAlign="left">
            <Text fontWeight="bold">About</Text>
            <Text mb={4}>{companyInfo.about}</Text>
            <Text fontWeight="bold">Location</Text>
            <Text mb={4}>{companyInfo.location}</Text>
            <Text fontWeight="bold">Contact</Text>
            <Text mb={4}>{companyInfo.contact}</Text>
          </TabPanel>

          <TabPanel overflowY="auto" >
            {jobs.map((job, index) => (
              <JobSuggestionCard key={index} {...job} />
            ))}
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
};

export default AboutCompany;
